import {
  FormControl as MuiFormControl,
  FormControlProps as MuiFormControlProps,
  styled
} from '@mui/material';

interface FormControlProps extends MuiFormControlProps {
  className?: string;
  dataId?: string;
}

const StyledFormControl = styled(MuiFormControl)(() => ({
  width: '100%',
  position: 'relative',
  marginBottom: '0 !important'
}));

export function FormControl({ className = '', children, ...props }: FormControlProps) {
  return (
    <StyledFormControl className={className} data-id={props.dataId} {...props}>
      {children}
    </StyledFormControl>
  );
}
